import Immutable from 'seamless-immutable'
import * as authenticationActions from 'external/reduxBits/authentication/actions'
import * as actions from './actions'

const initialState = Immutable.from({
  isFetching: true,
  isFetchingMoreAds: false,
  error: false,
  adwatchId: null,
  ads: [],
  totalCount: 0,
  nextScrollId: null,
  timestamp: null,
  haveMoreAds: false,
  showOnlyActive: false,
  numAdsPerPage: 40,
})

export default (state = initialState, { type, payload, error }) => {
  switch (type) {
    case authenticationActions.LOGOUT:
      return initialState
    case actions.REQUEST_AD_WATCH_ADS:
      return state.merge({
        isFetching: true,
        error: false,
      })
    case actions.RECEIVE_AD_WATCH_ADS:
      if (error) {
        return state.merge({
          error: payload,
          isFetching: false,
        })
      }
      return state.merge({
        isFetching: false,
        error: false,
        haveMoreAds: payload.ads.length < payload.totalCount,
        ...payload,
        // Flattens data model
        ads: payload.ads.map((item) => ({
          ...item.ad,
          isNew: item.isNew,
        })),
      })
    case actions.SET_ADWATCH_SHOW_ONLY_ACTIVE_ADS:
      return state.set('showOnlyActive', payload)
    case actions.RECEIVE_DELETE_AD_WATCH:
      if (!error) {
        return state.merge({
          adwatchId: null,
        })
      }

      return state
    case actions.RECEIVE_CREATE_AD_WATCH:
      if (!error) {
        return state.merge({
          adwatchId: null,
        })
      }

      return state
    case actions.REQUEST_MARK_ADWATCHES_READ:
      return state.merge({
        ads: state.ads.map((ad) => ({ ...ad, isNew: false })),
      })
    default:
      return state
  }
}
